module.exports = __webpack_public_path__ + "static/media/self-test-form.688e11a1.svg";